import { ApiCallError } from 'app/http/ApiCallError';
import { getApiCallErrorMessage } from 'app/http/getApiCallErrorMessage';

export const GENERIC_REQUEST_ERROR_MESSAGE = 'Something went wrong. Please try again later.';

export const getRequestErrorMessage = (error: unknown) =>
  error instanceof ApiCallError ? getApiCallErrorMessage(error) : GENERIC_REQUEST_ERROR_MESSAGE;
